import { http } from 'services/http';
import type { TCreateOrderWithCargosReq, TOrderRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useCreateOrderWithCargos = () => {
  return useMutationBase<TOrderRes, unknown, TCreateOrderWithCargosReq>({
    mutationFn: async (variables) => {
      const res = await http.post<TOrderRes>('/v1/orders/order-with-cargos', variables);

      return res.data;
    },
  });
};
